import LOGO_IMG from "../src/Components/Images/logo3.png";

export class B2BConstant {
  readonly BASE_URL = "https://kiosk-backend.nutritap.in/api/";
  readonly BASE_URL_AD = 'https://advertisement.nutritap.in/api/'
  // readonly BASE_URL = "http://localhost:8080/api/";
  // readonly BASE_URL= "https://db0d-103-170-153-34.ngrok-free.app/";
  // readonly BASE_URL = "http://nutritapserver:8080/api/"
  // readonly BASE_URL_AD = "http://nutritapserver:8081/api/"
  readonly USER_TOKEN = "USER_TOKEN";
  readonly USERNAME = "USERNAME";
  readonly USER_ID = "USER_ID";
  readonly CATALOGUE_ID = "CATALOGUE_ID";
  readonly EMAIL = "EMAIL";
  readonly ROLE = "ROLE";
  readonly PAGES = "PAGES";
  readonly PERMISSION = "PERMISSION";
  readonly PO_CLIENT = "PO_CLIENT";
  readonly ADDITIONAL_DETAILS = "ADDITIONAL_DETAILS"
  readonly CITY = "CITY";
  readonly ORGANIZATION = "ORGANIZATION";
  readonly MOBILE_NUMBER = "MOBILE_NUMBER";
  readonly CART = "CART";
  readonly NO_IMAGE = "No Image Found";
  readonly REGIONS = ["North", "South", "East", "West"];
  readonly COUNTRY = ["India"];
  readonly TEMP_PASS = "TEMP_PASS";
  readonly SAVE = "SAVE";
  readonly RAZORPAY_ORDER_ID = "razorpayOrderId";
  readonly TRANSACTION_ORDER_ID = "transactionOrderId";
  readonly LOGO = LOGO_IMG;
  readonly EXISTING_CLIENTS = [25,50,58,59,79,82,83,84,85,86,87,88,89,92,94];
  readonly GIFTING_BANNER = "https://nutritap.s3.ap-south-1.amazonaws.com/kiosk/Banner/Corporate+Gifting+20251127.png";
  readonly CORPORATE_GIFTING_BANNER = "https://nutritap.s3.ap-south-1.amazonaws.com/kiosk/Banner/Corporate+Gifting.png";
  readonly B2B_CONTACT_EMAIL = "b2b@nutritap.in";



}

export const B2BConstants = new B2BConstant();
